import DealCard from './DealCard';

export default function RecommendationsSection({ recommendations, shoppingList, favourites, onAddToList, onToggleFavourite, onSeeAll }) {
  if (!recommendations?.length) return null;

  const listSet = new Set((shoppingList || []).map(i => i.name + i.store));
  const favSet  = new Set((favourites   || []).map(f => f.name + f.store));
  const preview = recommendations.slice(0, 4);

  return (
    <section className="recs-section">
      <div className="recs-header">
        <div>
          <h2 className="recs-title">✦ Picks for you</h2>
          <p className="recs-subtitle">Based on your shopping history &amp; favourites</p>
        </div>
        <button className="recs-see-all" onClick={onSeeAll}>
          See all {recommendations.length} →
        </button>
      </div>
      <div className="recs-grid">
        {preview.map((deal, i) => (
          <div key={i} className="rec-card-wrap">
            <div className="rec-reason">{deal.reason}</div>
            <DealCard
              deal={deal}
              onAddToList={onAddToList}
              inList={listSet.has(deal.name + deal.store)}
              isFavourited={favSet.has(deal.name + deal.store)}
              onToggleFavourite={onToggleFavourite}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
